"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCPStateActionBuilder = void 0;
var pin_standard_1 = require("@microchip/pin-standard");
var PCPStateActionBuilder = /** @class */ (function () {
    function PCPStateActionBuilder(pinRow) {
        this.actionDataArr = [];
        this.pinRow = pinRow;
        this.tabId = "main";
    }
    PCPStateActionBuilder.prototype.rowWithName = function (rowName) {
        this.rowName = rowName;
        return this;
    };
    /**
     *
     * @param tabId - default tabId is "main", please change this as per your needs.
     * @returns PCPStateActionBuilder
     */
    PCPStateActionBuilder.prototype.compWithTabId = function (tabId) {
        this.tabId = tabId;
        return this;
    };
    PCPStateActionBuilder.prototype.addIfLockedSetValue = function (pinRegEx, value) {
        this.actionDataArr.push({
            pinstate: pin_standard_1.pin_state.LOCKED,
            validFor: pinRegEx,
            value: value,
            actiontype: pin_standard_1.actiontype.SETACTION,
        });
        return this;
    };
    PCPStateActionBuilder.prototype.addIfLockedProvideAttribs = function (pinRegEx, attribs) {
        this.actionDataArr.push({
            pinstate: pin_standard_1.pin_state.LOCKED,
            validFor: pinRegEx,
            value: this.formAttribs(attribs),
            actiontype: pin_standard_1.actiontype.ATTRIBACTION,
        });
        return this;
    };
    PCPStateActionBuilder.prototype.addIfUnlockedProvideAttribs = function (pinRegEx, attribs) {
        this.actionDataArr.push({
            pinstate: pin_standard_1.pin_state.UNLOCK,
            validFor: pinRegEx,
            value: this.formAttribs(attribs),
            actiontype: pin_standard_1.actiontype.ATTRIBACTION,
        });
        return this;
    };
    PCPStateActionBuilder.prototype.formAttribs = function (attribarray) {
        return {
            attribs: attribarray,
        };
    };
    PCPStateActionBuilder.prototype.addIfUnLockedSetValue = function (pinRegEx, value) {
        this.actionDataArr.push({
            pinstate: pin_standard_1.pin_state.UNLOCK,
            validFor: pinRegEx,
            value: value,
            actiontype: pin_standard_1.actiontype.SETACTION,
        });
        return this;
    };
    PCPStateActionBuilder.prototype.forComponent = function (component) {
        this.component = component;
        return this;
    };
    PCPStateActionBuilder.prototype.build = function () {
        var _this = this;
        var actionArr = [];
        if (this.pinRow.name === this.rowName) {
            this.actionDataArr.forEach(function (eachData) {
                var _a;
                var _b;
                actionArr.push({
                    validFor: eachData.validFor,
                    state: (_a = {},
                        _a[eachData.pinstate] = {
                            type: "[FORM] SUBMIT",
                            payload: {
                                tabId: _this.tabId,
                                path: _this.component.group + "." + _this.component.name,
                                value: eachData.value,
                            },
                        },
                        _a),
                    actiontype: (_b = eachData.actiontype) !== null && _b !== void 0 ? _b : "",
                });
            });
        }
        return actionArr;
    };
    return PCPStateActionBuilder;
}());
exports.PCPStateActionBuilder = PCPStateActionBuilder;
/*
 PCPHelper
            .stateActionBuilder(rowData)
            .rowWithName("dacoutx")
            .forComponent(dacOPEnCompo)
            .addIfLockedSetValue("DAC1OUT1", "DACOUT1 Enabled and DACOUT2 Disabled")
            .addIfLockedSetValue("DAC1OUT2", "DACOUT2 Enabled and DACOUT1 Disabled")
            .addIfUnLockedSetValue(".*", "DACOUT1 and DACOUT2 are Disabled")
            .build()
*/
//# sourceMappingURL=PCPStateActionBuilder.js.map